module.exports = __webpack_public_path__ + "49fb056f38919ecd9a4ebeec23b49814.png";